import { useEffect } from "react";

const BASE_TITLE = "Altura of America";

/** Sets the browser tab title to `"<page> · Altura of America"`, restoring the previous title on unmount. */
export function useDocumentTitle(page?: string | null) {
  useEffect(() => {
    const previous = document.title;
    document.title = page ? `${page} · ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = previous;
    };
  }, [page]);
}
